module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "right-panel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Join WorkGroup")])], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    staticStyle: {
      "height": "100%"
    },
    slot: "content"
  }, [_c('el-form', {
    ref: "workgroupForm",
    staticClass: "workgroupForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.workgroupForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "project_ids"
    }
  }, [_c('el-select', {
    ref: "workgroups",
    attrs: {
      "multiple": "",
      "filterable": "",
      "placeholder": _vm.attrText.inputName,
      "loading": _vm.loading
    },
    on: {
      "change": _vm.onChangeSelect
    },
    model: {
      value: (_vm.workgroupForm.project_ids),
      callback: function($$v) {
        _vm.workgroupForm.project_ids = $$v
      },
      expression: "workgroupForm.project_ids"
    }
  }, _vm._l((_vm.workgroupForm.list), function(item) {
    return _c('el-option', {
      key: item.id,
      staticClass: "select-item",
      attrs: {
        "label": item.name,
        "value": item.id
      }
    }, [_vm._v(" " + _vm._s(item.name)), _c('br'), _vm._v(_vm._s(item.account) + " ")])
  }))], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.workgroupForm.project_ids.length
    },
    on: {
      "click": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_c('translate', [_vm._v("Submit")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$refs['right-panel'].onClose()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fbadf5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/model/group-add-workgroup.vue
// module id = 545
// module chunks = 4 5 6